import { Card, CardSection, Stack } from '@servicetitan/design-system';
import { CardContainer } from './CustomerCardWrapper.styled';

interface CustomerCardProps {
  children: React.ReactNode;
}

// renders the children wrapped by a Card and CardSection
const CustomerCardWrapper = ({ children }: CustomerCardProps) => {
  return (
    <CardContainer>
      <Card>
        <CardSection className='p-t-2 p-b-2'>
          <Stack direction='column' spacing={2}>
            {children}
          </Stack>
        </CardSection>
      </Card>
    </CardContainer>
  );
};

export default CustomerCardWrapper;
